<script>
  import {getContext, onMount} from 'svelte';
  import {IMAGES, PATHS} from '@/const';
  import {langUtil} from '@/helper/lang';
  import {mc} from '@/core';
  import {isLogin$} from '@/store/user';
  import {fixLink$} from '@/store/lang';
  import {env, envUtil} from '@/helper';
  import {gotoRegisterWithRedirect} from '@/modules/header/util';
  import Download from './DownloadNew.svelte';
  import SidebarDropDown from '../popups/sidebar/SidebarDropDown.svelte';
  import lang from '../Header.lang';

  const LG = getContext('LG');
  const DOWNLOAD_BLACKLIST = [PATHS.DOWNLOAD.pathname]

  export let isTop = false;
  export let isFixed = true;
  export let modalUI = false;
  export let isHome = false;
  export let isLogin = false;

  let navigationShow = false;
  let rightWidth = '-100%';

  onMount(() => {
    const {pathname} = window.location;
    const name = langUtil.parsePathname(pathname).pathname;
  });

  function handleClickClose() {
    navigationShow = !navigationShow;
    if (navigationShow) {
      isTop = false;
      rightWidth = '0';
      return;
    }
    rightWidth = '-100%';
  }

  function handleStopClick(e) {
    e.stopPropagation();
  }

  function handleClickRegister() {
    if (modalUI) {
      mc.send('modal-register', 'startRegister');
    } else {
      gotoRegisterWithRedirect($fixLink$);
    }
  }
</script>

<style>
  .logo {
    width: 106px;
    height: 24px;
  }
  .header {
    z-index: 999;
    width: 100%;
    background: #090A0A;
  }
  .header.top {
    position: relative;
    top: 0 !important;
    height: 0;
    background: transparent;
  }
  .header.log {
    border-bottom: 1px solid #1f242e;
    height: 40px;
    background: #010612;
  }
  .fixed {
    position: fixed;
    top: 0;
  }
  .content {
    padding: 0 16px;
    height: 40px;
  }
  .btn {
    display: inline-block;
    padding: 0 14px;
    line-height: 28px;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    background-color: #0345f5;
    color: #fff;
    cursor: pointer;
    text-decoration: none;
    border-width: 0;
    border-radius: 24px;
  }
  .menu {
    position: fixed;
    top: 0;
    right: -100%;
    bottom: 0;
    z-index: 1999;
    margin: 0;
    padding: 20px 0 60px;
    width: 100%;
    background: #090A0A;
    color: #fff;
    transition: 0.3s;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
  }
  .top .cf {
  }
  .top .btn {
    border: none;
  }
</style>

<div class="main">
  <div class:mask={navigationShow} on:click={handleClickClose} />
  <div class="header" class:header-h5={env.isMobile || env.isApp} class:top={isTop} class:fixed={isFixed} class:log={isLogin}>
    {#if envUtil.isMobile && !DOWNLOAD_BLACKLIST.includes(location.pathname)}
      <Download />
    {/if}
    <div class="df jcsb content">
      <a class="df aic" href={$fixLink$(PATHS.HOME.pathname)}>
        <img class="logo" alt="Logo" src={IMAGES.LOGO_LIGHT} />
      </a>
      <div class="df aic jcc">
        {#if !$isLogin$}
          <a class="btn ph12 ga" href="javascript:;" on:click={handleClickRegister}>
            <span>{LG(lang.SignUp)}</span>
          </a>
        {/if}
        <i class="iconfont ml20 lh16 f12" class:cf={isTop || isLogin} class:dn={isLogin} on:click={handleClickClose}>&#xe662;</i>
      </div>
    </div>
  </div>
  <div class="menu" style="right:{rightWidth}" on:click={handleStopClick}>
    <SidebarDropDown on:handleClickClose={handleClickClose} {modalUI}  />
  </div>
</div>
